<template>
  <div id="totalBox">
    <div class="payBox">
      <div class="payContent">
        <p class="payContentTitle">先离场后缴费</p>
        <p class="paycontentTip">无感支付</p>
        <div class="payIconBox">
          <img src="../../assets/home/payIcon.png" class="payIcon" alt="" />
        </div>
        <ul class="payListBox">
          <li class="payList">
            <img src="../../assets/home/select.png" class="selectIcon"/>
            <div class="payListContent">率先突破“双网并行”智慧（共享）停车场运营黑科技</div>
          </li>
          <li class="payList">
            <img src="../../assets/home/select.png" class="selectIcon"/>
            <div class="payListContent">率先实现杭州城市大脑“先离场后缴费”新模式</div>
          </li>
          <li class="payList">
            <img src="../../assets/home/select.png" class="selectIcon"/>
            <div class="payListContent">率先集成中国建行、杭州联合银行等无感支付新范式</div>
          </li>
          <li class="payList">
            <img src="../../assets/home/select.png" class="selectIcon"/>
            <div class="payListContent">率先支持银联、支付宝、微信等聚合支付新支付</div>
          </li>
          <li class="payList">
            <img src="../../assets/home/select.png" class="selectIcon"/>
            <div class="payListContent">打造星级智慧停车，彻底改变传统车场落后的经营模式</div>
          </li>
        </ul>
      </div>
      <div class="payImgBox">
        <img src="../../assets/home/payImg.png" class="payImg"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pay',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  background-color: RGBA(248, 248, 248, 1);
  height: 800px;
}
.payBox{
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
}
.payContent{
  height: 100%;
  width: 425px;
  padding-top:129px;
  padding-left: 61px;
  margin-right: 120px;
}
.payContentTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  text-align: left;
}
.paycontentTip{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  margin-top: 30px;
  text-align: left;
}
.payIconBox{
  text-align: left;
}
.payIcon{
  width:58px;
  height:22px;
  margin-top: 24px;
}
.payListBox{
  margin-top: 32px;
}
.payList{
  margin-top: 27px;
  display: flex;
  align-items: flex-start;
}
.selectIcon{
  width: 24px;
  height: 24px;
  margin-right: 14px;
  margin-top: 2px;
}
.payListContent{
  font-size:18px;
  font-weight:400;
  color:rgba(80,80,80,1);
  text-align: left;
}
.payImgBox{
  padding-top: 57px;
}
.payImg{
  width: 594px;
  height: 696px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/pay.vue